<template>
    <div class="animated fadeIn">
        <b-tabs nav-wrapper-class="w-40" v-model.number='report_tab'  @input="resetData()">
            <b-tab  >

                <template slot="title"><i class="icon-book-open"></i> Финансы</template>

                <p>
                    Отчет показывает список путевок с расчетом всех сумм за указанный период.
                </p>

                <report-dates v-model="date_type" :types="['checkin', 'checkout', 'created', 'combined_dates', 'invoice_date', 'invoice_payed']"></report-dates>

                <template v-if="report_tab==0">
                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @input="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="use_profkurort" value="1" v-model="use_profkurort">
                            <label class="custom-control-label" for="use_profkurort">Учитывать профкурорт</label>
                        </div>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhFinanceAll"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=9e977106-3e8f-46d2-8471-78c483035d77</p>
            </b-tab>

            <b-tab  >
                <template slot="title"><i class="icon-book-open"></i> Профкурорт</template>

                <p>
                    Отчет показывает список путевок оформленных через ПРОФКУРОРТ за указанный период.
                </p>

                <template v-if="report_tab==1">
                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <report-dates v-model="date_type" :types="['checkin', 'checkout', 'created', 'invoice_date', 'invoice_payed']"></report-dates>

                    <b-form-group label="Город" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @input="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="use_unfilled" value="1" v-model="use_unfilled">
                            <label class="custom-control-label" for="use_unfilled">Учитывать незаполненные <span class="text-danger">(не работает так как я не понял)</span></label>
                        </div>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhFinancePk"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>

                <p>WID=98a1ad6e-92f8-403c-aced-180241e2a78a</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> Заезды</template>
                <p>
                    Отчет показывает список путевок с датами заездов заезжающих за указанный период.
                </p>

                <template v-if="report_tab==2">
                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @input="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Агент" :label-cols="3" :horizontal="false   ">
                        <v-select v-model="agent_id"  :options="_agents" label="full_name" :reduce="x => x.id"></v-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhFinanceCheckins"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=a9e7396d-b92a-4007-b10b-72740ec7a7e5</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> Вознаграждение</template>
                <p>
                    Отчет показывает вознаграждение от объектов за указанный период.
                </p>

                <template v-if="report_tab==3">
                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <report-dates
                        v-model="date_type"
                        :types="['checkin', 'checkout', 'any_period_day', 'created', 'combined_dates', 'invoice_payed']"
                        v-validate="{required:true}"
                        :invalid_feedback="veeErrors.first('fee_date_type')"
                        :validation_state="validateState('fee_date_type')"
                        name="fee_date_type"
                        data-vv-as="'Период отчета'"
                        data-vv-name="fee_date_type"
                    ></report-dates>

                    <b-form-group
                        label=""
                        :label-cols="3"
                        :horizontal="false"
                        description="Данная опция работает для периодов отчета: 'По дате заезда', 'По дате выезда', и 'По дате оплаты счета объекта'.
                        Для периода отчета 'По дате начисления вознаграждения' отбираются только путевки у которых дата начисления вознаграждения
                        попадает в период отчета. "
                    >
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="only_selected_vouchers" value="1" v-model="only_selected_vouchers">
                            <label class="custom-control-label" for="only_selected_vouchers">Включать только путевки, вознаграждение от объектов для которых начисляется в соответствии с выбранным типом дат</label>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @change="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Агент" :label-cols="3" :horizontal="false   ">
                        <v-select v-model="agent_id" :options="_agents" label="full_name" :reduce="x => x.id"></v-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhFinanceFee"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=ffd145a1-ca79-424d-a064-24fd7d16e237</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> Исходящие платежи</template>
                <p>
                    Отчет показывает исходящие платежи (оплаты, записи), которые прошли по учетным данным.
                </p>

                <template v-if="report_tab==4">
                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город: (какой нафиг смысл в этом фильтре? я их не делаю) " :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания: (какой нафиг смысл в этом фильтре?  я их не делаю) " :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @input="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="only_errors" value="1" v-model="only_errors">
                            <label class="custom-control-label" for="only_errors">Только ошибки</label>
                        </div>
                    </b-form-group>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhFinancePayments"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=a0ba60d8-9574-44c8-90e6-73bb9487ad7f</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> График платежей</template>

                <template v-if="report_tab==5">

                    <p>График платежей по старой схеме, где использованы данные путевок.</p>

                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <report-dates v-model="date_type" :types="['checkin',  'invoice_date']"></report-dates>

                    <b-form-group label="Город: (какой нафиг смысл в этом фильтре? я их не делаю)" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group
                        label=""  :label-cols="3" :horizontal="false"
                        description='Путевки с флагом "квота в отчет не включаются"'
                    >
                        <b-button block variant="primary" @click="_reportBuhFinanceVouchersToPay"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=373694d2-1dde-45e0-b78e-d18127933fdf</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> Проблемные путевки</template>

                <template v-if="report_tab==6">

                    <p>Отчет показывает путевки с различными проблемами</p>

                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <report-dates v-model="date_type" :types="['created', 'checkin', 'checkout']"></report-dates>

                    <report-types
                        v-model="report_type"
                        :types="['errors_no_bookings', 'errors_multiple_bookings', 'errors_no_payment_date', 'errors_no_payment_date_all', ]"
                        :invalid_feedback="veeErrors.first('report_type')"
                        :validation_state="validateState('report_type')"
                        v-validate="{required:true}"
                        name="report_type"
                        data-vv-as="'Тип отчета'"
                        data-vv-name="report_type"
                    ></report-types>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhProblemVouchers"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=beb4414d-f561-4951-a4b6-a270a1b2a1f3</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> График платежей<sup>нов</sup></template>

                <template v-if="report_tab==7">

                    <p>График платежей по новой схеме, где использованы данные броней.</p>

                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <report-dates v-model="date_type" :types="['checkin',  'invoice_redemption_date',  'invoice_date']"></report-dates>

                    <b-form-group label="Город" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @change="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group
                        label=""  :label-cols="3" :horizontal="false"
                        description='Путевки с флагом "квота в отчет не включаются"'
                    >
                        <b-button block variant="primary" @click="_reportBuhFinanceBookingsToPay"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=c03b400e-4e96-484d-a71d-28c79b38f98d</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> Выполненные</template>

                <template v-if="report_tab==8">

                    <p>
                        Старый отчет тут
                        <a href="https://zt.nsb.su/nsb-system-analytics/reports-vouchers-execute/">
                            НСБ › Система › Аналитика › Система › Путевки › Выполненные</a>
                    </p>

                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Город" :label-cols="3" :horizontal="false">
                        <v-select v-model="city_id" @input="hotel_id=null" :options="cities" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group label="Компания" :label-cols="3" :horizontal="false">
                        <v-select v-model="company_id" @change="agent_id=null" :options="_companies" label="title" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <report-types
                        v-model="report_type"
                        :types="['detailed', 'groupbyhotel', ]"
                        :invalid_feedback="veeErrors.first('report_type')"
                        :validation_state="validateState('report_type')"
                        v-validate="{required:true}"
                        name="report_type"
                        data-vv-as="'Тип отчета'"
                        data-vv-name="report_type"
                    ></report-types>

                    <b-form-group label=""  :label-cols="3" :horizontal="false">
                        <b-button block variant="primary" @click="_reportBuhVouchersFinished"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=c1434563-a533-4d70-bcf1-a7df8a09a239</p>
            </b-tab>

            <b-tab >
                <template slot="title"><i class="icon-book-open"></i> Квоты</template>

                <template v-if="report_tab==9">

                    <b-form-group
                        label="Диапазон дат"
                        :label-cols="3"
                        :horizontal="false"
                        :invalid-feedback="veeErrors.first('date_range')"
                        :state="validateState('date_range')"
                    >
                        <div class="input-group">
                            <v-date-picker
                                mode='range'
                                is-double-paned
                                v-model='date_range'
                                v-validate="{required:true}"
                                name="date_range"
                                data-vv-as="'Диапазон дат'"
                                :state="validateState('date_range')"
                            ></v-date-picker>
                            <b-button type="button" variant="secondary"  @click='resetDateRange()'><i class="fa fa-times-circle"></i> </b-button>
                        </div>
                    </b-form-group>

                    <b-form-group label="Объект" :label-cols="3" :horizontal="false">
                        <v-select v-model="hotel_id" :options="_hotels" label="title_decorated" :reduce="x => x.id" ></v-select>
                    </b-form-group>

                    <b-form-group
                        label=""  :label-cols="3" :horizontal="false"
                        description="отбор производится по дате заезда"
                    >
                        <b-button block variant="primary" @click="_reportBuhVoucherQuotes"><i class="fa fa-download"></i> Построить отчет</b-button>
                    </b-form-group>
                </template>
                <p>WID=ced10c68-5cd0-4094-8596-2e57fb0684c0</p>
            </b-tab>

        </b-tabs>

        <br>

        <b-card v-if="reports.length">
            <ul>
                <li v-for="r in reports">
                    <a :href="r.report_url" target="_blank">{{r.report_title}}</a>
                </li>
            </ul>
        </b-card>

        <p>WID=aa055460-d6fd-4460-93e1-3745a89ab3f2</p>

    </div>
</template>

<script>
    import { functions } from '@/functions';
    import { functions_loaders } from '@/functions_loaders';
    import { functions_company } from '@/functions/company.js';
    import { functions_report } from '@/functions_report';
    import { functions_hotel } from '@/functions/hotel.js';
    import { functions_city } from '@/functions_city.js';
    import ReportTypes from '@/components/ReportTypes';
    import ReportDates from '@/components/ReportDates';

    const today = new Date()

    export default {
        name: 'NsbBuhReports',
        mixins: [functions, functions_loaders, functions_report, functions_company, functions_hotel, functions_city,],
        components: {
            ReportTypes,
            ReportDates
        },
        data: function () {
            return {
                report_tab: null,

                hotel_id: null,
                city_id: null,
                agent_id: null,
                company_id: null,
                report_type:null,
                date_type:null,
                date_range:null,
                use_profkurort:true,
                use_unfilled:false,
                only_errors: false,
                only_selected_vouchers: false,
            }
        },
        methods: {
            resetDateRange: function() {
                this.date_range = null;
            },


            resetData: function () {
                this.hotel_id = null;
                this.city_id = null;
                this.agent_id = null;
                this.company_id = null;
                this.report_type = null;
                this.date_type = null;
                this.use_profkurort = true;
                this.use_unfilled = false;
                this.only_errors = false;
            },

            _reportBuhFinanceAll: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinanceAll(this.date_range_start, this.date_range_end, this.date_type, this.city_id, this.hotel_id, this.company_id, this.use_profkurort);
                });
            },

            _reportBuhFinancePk: function() {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinancePk(this.date_range_start, this.date_range_end, this.date_type, this.city_id, this.hotel_id, this.company_id, this.use_unfilled);
                });
            },

            _reportBuhFinanceCheckins: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinanceCheckins(this.date_range_start, this.date_range_end, this.city_id, this.hotel_id, this.company_id, this.agent_id);
                });
            },

            _reportBuhFinanceFee: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinanceFee(this.date_range_start, this.date_range_end, this.date_type, this.city_id, this.hotel_id, this.company_id, this.agent_id, this.only_selected_vouchers);
                });

            },

            _reportBuhFinancePayments: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinancePayments(this.date_range_start, this.date_range_end, this.city_id, this.hotel_id, this.company_id, this.only_errors);
                });
            },

            _reportBuhFinanceVouchersToPay: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinanceVouchersToPay(this.date_range_start, this.date_range_end, this.date_type, this.city_id, this.hotel_id);
                });
            },

            _reportBuhProblemVouchers: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhProblemVouchers(this.date_range_start, this.date_range_end, this.date_type, this.report_type);
                });
            },

            _reportBuhFinanceBookingsToPay: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhFinanceBookingsToPay(this.date_range_start, this.date_range_end, this.date_type, this.hotel_id);
                });
            },

            _reportBuhVouchersFinished: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhVouchersFinished(this.date_range_start, this.date_range_end, this.city_id, this.hotel_id, this.company_id, this.report_type);
                });
            },

            _reportBuhVoucherQuotes: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) this.reportBuhVoucherQuotes(this.date_range_start, this.date_range_end, this.hotel_id);
                });
            },


        },
        computed: {
            _agents: function () {
                let self = this;
                return this.users.filter(function(user) {
                    if (self.company_id) {
                        return user.company_id === self.company_id;
                    }
                    else {
                        return true;
                    }
                });
            },

            _hotels: function () {
                let self = this;
                return this.hotels.filter(function(hotel) {
                    if (self.city_id) {
                        return hotel.t_city_id === self.city_id;
                    }
                    else {
                        return true;
                    }
                });
            },

            _companies: function () {
                let self = this;
                return this.companies.filter(function(company) {
                    return company.type & 1 ;
                });
            },

            date_range_start: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.start).toLocaleDateString()
                return null;
            },
            date_range_end: function () {
                if (this.date_range !== null)
                    return new Date(this.date_range.end).toLocaleDateString()
                return null;
            },
        },
        created: function() {
            this.loadHotels();
            this.loadCities();
            this.loadCompanies();
            this.loadUsers();
        }
    };
</script>

<style lang="scss">
</style>

